import Personnummer from 'personnummer';

export const ageResolver = (cpr: string) => Personnummer.parse(cpr).getAge();
